module.exports = __webpack_public_path__ + "static/media/VISA.a102d8a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/PaymentModes/VISA.svg
// module id = 905
// module chunks = 0